import type { ParsedLocation, RouterHistory } from '@tanstack/react-router';
import { useNavigate, useRouter, useRouterState } from '@tanstack/react-router';
import { useCallback } from 'react';

/** This hook provides strongly-typed to the router history without needing the typed router */
export function useRouterHistory() {
	const router = useRouter();
	return router.history as RouterHistory;
}

export function useCurrentLocation(): ParsedLocation {
	return useRouterState({
		select: s => s.location,
	});
}

export function useBackOrNavigate() {
	const history = useRouterHistory();
	const navigate = useNavigate();
	const location = useCurrentLocation();

	return useCallback(
		async (listRoute: string) => {
			if (history.canGoBack() && location.state?.from?.pathname === listRoute) {
				history.back();
			} else {
				await navigate({ to: listRoute });
			}
		},
		[history, navigate, location],
	);
}
